import { ComponentInfo } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const trustPilotMicroComboInputs = [
  {
    name: "theme",
    type: "string",
    enum: ["light", "dark"],
    required: true,
    defaultValue: "light",
  },
  {
    name: "width",
    type: "string",
    defaultValue: "100%",
  },
  {
    name: "height",
    type: "string",
    defaultValue: "20px",
  },
] as const satisfies ComponentInfo["inputs"];

export type TrustPilotMicroComboProps = BuilderComponentProps<
  typeof trustPilotMicroComboInputs
>;

export const TrustPilotMicroComboComponent: RegisteredComponent = {
  name: "TrustPilotMicroCombo",
  component: dynamic(async () =>
    withValidation(
      trustPilotMicroComboInputs,
      (await import("./TrustPilotMicroCombo")).TrustPilotMicroCombo,
      "TrustPilotMicroCombo"
    )
  ),
  inputs: trustPilotMicroComboInputs,
};
